/**
 * When the web stage stops floating the self-view.
 *
 * With one to five remote signers the self-view floats as a movable inset;
 * the three-column grid leaves its bottom-right cell empty in every case
 * but three and six, and at three the letterboxed video clears the inset.
 * At six remote tiles (3 × 2) the inset sits on the sixth signer's hands at
 * 1366 × 768, and from six on the tiles are small enough that a grid cell
 * costs the others almost nothing: 7 or 8 tiles in three columns are
 * 427 × 240 video each at 1366 × 768, against 439 × 247 for six. So the
 * self-view takes a cell, after everyone else.
 */
export const SELF_VIEW_DOCK_MIN_REMOTES = 6;
/**
 * Whether the self-view takes a grid cell instead of floating.
 *
 * @param {number} remoteCount - Remote participants with a tile.
 * @returns {boolean}
 */
export function selfViewDocksInGrid(remoteCount) {
    return remoteCount >= SELF_VIEW_DOCK_MIN_REMOTES;
}
